import React, { useContext, useEffect, useState } from "react";
import { createTheme, makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { Router, useLocation } from 'react-router-dom';
import Routes from '../../RoutesInApp';
import History from '../../Services/History';
import AppContext from '../../Services/AppContext';
import { CookiesProvider } from 'react-cookie';
import { SnackbarProvider } from 'notistack';
import grey from '@material-ui/core/colors/grey';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import GTranslateRoundedIcon from '@material-ui/icons/GTranslateRounded';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PersistantData from "../../Services/PersistantData";
import { Offline } from 'react-detect-offline';
import _ from 'lodash';
import {
	ck_lang,
	ck_theme,
	ck_u_client,
	ck_u_device_no,
	ck_u_position,
	ck_u_role_id,
	ck_u_username,
	cookieClear,
	empty,
	req_mobile_module_setting,
	req_module_setting,
	req_setting
} from "../../Helper/Constants";
import JString from '@easytech-international-sdn-bhd/jstring';
import CryptData from "../../Helper/CryptData";
import Alert from '../../Components/Alert';
import MuiAlert from '@material-ui/lab/Alert';
import Sidebar from '../../Components/Sidebar';
import { getSetting, isPromoter, isMerchandiser } from "../../Helper/Helper";
import { isAdvancedPhotoGalleryEnabled } from "../../Helper/SystemSettings";
import useCookieHook from "../../Services/useCookieHook";
import LiveUpdate from "../../Components/LiveUpdate";
import AnnouncementBell from "../../Components/AnnouncementBell";
import TutorialVideoDialog from "../../Components/TutorialVideoDialog";
import API_Service, { axiosDefaultConfig } from "../../Services/API_Service";
import HelpIcon from '@material-ui/icons/Help';
import { CircularProgress, Tooltip } from "@material-ui/core";

const drawerWidth = 275;

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		backgroundColor: '#FEF200',
		color: 'black',
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	hide: {
		display: 'none',
	},
	content_toolbar: {
		...theme.mixins.toolbar
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		scrollbarWidth: 'none',
		'-ms-overflow-style': 'none',
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
	title: {
		flexGrow: 1,
	},
	whiteText: {
		color: 'white'
	},
	contentLoader: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '80vh'
	},
	liveUpdateSpacer: {
		width: 20
	}
}));

function MAlert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function MainView() {
	const classes = useStyles();

	const singleton = PersistantData.getInstance();

	const currentRoute = useLocation();

	const [gState, setGState] = useContext(AppContext);
	const [availableModules, setAvailableModules] = useState([]);
	const [availableTutorials, setAvailableTutorials] = useState([]);
	const [modules, setModules] = useState([]);
	const [logoUrl, setlogoUrl] = useState(null);
	const [companyName, setCompanyName] = useState(null);
	const [displayReport, setDisplayReport] = useState(false);
	const [competitorModule, setCompetitorModule] = useState(false);
	const [surveyModule, setSurveyModule] = useState(false);
	const [surveyResponseModule, setSurveyResponseModule] = useState(false);
	const [csrActivityModule, setCsrActivityModule] = useState(false);
	const [itemDistAnalysisReport, setItemDistAnalysisReport] = useState(false);
	const [itemDistAnalysisReportByAgent, setItemDistAnalysisReportByAgent] = useState(false);
	const [stockNearExpiryAnalysisByItem, setStockNearExpiryAnalysisByItem] = useState(false);
	const [defaultPhotoGallery, setDefaultPhotoGallery] = useState(false);
	const [photoGalleryConfigLoaded, setPhotoGalleryConfigLoaded] = useState(false);
	const [stockNearExpiryAnalysisByDayModule, setStockNearExpiryAnalysisByDayModule] = useState(false);
	const [oosInsightModule, setOosInsightModule] = useState(false);
	const [manageUsersModule, setManageUsersModule] = useState(false);
	const [customization, setCustomization] = useState(undefined);
	const [modulesLoaded, setModulesLoaded] = useState(false);
	const [powerBIConfig, setPowerBIConfig] = useState({});
	const [cookies, setCookie, removeCookie] = useCookieHook([ck_theme, ck_lang, ck_u_role_id, ck_u_device_no, ck_u_position]);
	const [loadingConfig, setLoadingConfig] = useState(!!cookies(ck_u_client));

	const defLang = cookies(ck_lang);
	const defTheme = cookies(ck_theme) || "dark";
	var isAdmin = cookies(ck_u_role_id);

	singleton.setlang(defLang);
	const deviceNo = cookies(ck_u_device_no);
	const defUsername = cookies(ck_u_username);
	var u_client = cookies(ck_u_client);
	var u_position = cookies(ck_u_position);
	if (JString(defUsername).isValid()) {
		u_client = JString(u_client).isValid() ?
			new CryptData(u_client, defUsername)
				.decryptAES()
				.getValue()
			: empty;
		isAdmin = JString(isAdmin).isValid() ?
			new CryptData(isAdmin, defUsername)
				.decryptAES()
				.getValue()
			: 5;
		u_position = JString(u_position).isValid() ?
			new CryptData(u_position, defUsername)
				.decryptAES()
				.getValue()
			: '{}';
	}
	const promoterMode = isPromoter(u_position);
	const merchandiserMode = isMerchandiser(u_position);
	singleton.setUsername(defUsername);

	var sessionId = document.cookie.match(/sessionId=[^;]+/) + '';
	if (sessionId === null) {
		sessionId = Math.floor(Math.random() * 1000);
	}
	var res = sessionId.split("=");
	if (res.length > 0) {
		sessionId = res[1];
	}

	const defaultRoutes = {
		[`/main/dashboard`]: singleton.getlang()?.dashboard,
		[`/main`]: singleton.getlang()?.dashboard,
		[`/main/transactions`]: singleton.getlang()?.transaction,
		[`/main/useraccounts`]: singleton.getlang()?.user_accounts,
		[`/main/reconciliation`]: singleton.getlang()?.reconciliation,
		[`/main/stocklist`]: singleton.getlang()?.stock,
		[`/main/bundle`]: singleton.getlang()?.bundle,
		[`/main/customer`]: singleton.getlang()?.customer,
		[`/main/appcontent`]: singleton.getlang()?.app_content,
		[`/main/announcement`]: singleton.getlang()?.announcement,
		[`/main/eventitems`]: singleton.getlang()?.event_items,
		[`/main/checkin`]: singleton.getlang()?.checkin,
		[`/main/promotercheckin`]: singleton.getlang()?.checkin,
		[`/main/dob`]: singleton.getlang()?.dob,
		[`/main/stocktransfer`]: singleton.getlang()?.stock_transaction,
		[`/main/stocktake`]: singleton.getlang()?.stock_take,
		[`/main/target`]: singleton.getlang()?.target,
		[`/main/cashrolling`]: singleton.getlang()?.cashrolling,
		[`/main/report`]: singleton.getlang()?.report,
		[`/main/backendsync`]: singleton.getlang()?.backend_sync,
		[`/main/modulelinkage`]: singleton.getlang()?.module_linkage,
		[`/main/B2BOrder`]: singleton.getlang()?.b2border,
		[`/main/stocktemplate`]: singleton.getlang()?.stock_template,
		[`/main/managesched`]: singleton.getlang()?.manage_sched,
		[`/main/ragentattend`]: singleton.getlang()?.agent_attend,
		[`/main/rpromoterattend`]: singleton.getlang()?.promoter_attend,
		[`/main/roos`]: singleton.getlang()?.oos,
		[`/main/routletvisit`]: singleton.getlang()?.outlet_visit,
		[`/main/rstocktake`]: singleton.getlang()?.stock_take,
		[`/main/rstocknearexpiry`]: singleton.getlang()?.stock_near_expiry,
		[`/main/rposm`]: gState.client && gState.client.includes('liansin') ? singleton.getlang()?.posm : singleton.getlang()?.checklist,
		[`/main/routletvisitanalysis`]: singleton.getlang()?.outlet_visit_analysis,
		[`/main/promoterroutletvisitanalysis`]: singleton.getlang()?.outlet_visit_analysis,
		[`/main/rphototakenanalysis`]: singleton.getlang()?.photo_taken_analysis,
		[`/main/rstocknearexpiryanalysis`]: singleton.getlang()?.stock_near_expiry_analysis,
		[`/main/rstocknearexpiryanalysisbyday`]: singleton.getlang()?.stock_near_expiry_analysis_by_day,
		[`/main/rstocknearexpiryanalysisbyitem`]: singleton.getlang()?.stock_near_expiry_analysis_by_item,
		[`/main/usersettings`]: singleton.getlang()?.user_settings,
		[`/main/audittrailoutlet`]: singleton.getlang()?.audit_trail,
		[`/main/gallery`]: singleton.getlang()?.photo_gallery,
		[`/main/promotergallery`]: singleton.getlang()?.photo_gallery,
		[`/main/promotergallery2`]: singleton.getlang()?.photo_gallery,
		[`/main/rincentive`]: singleton.getlang()?.incentive,
		[`/main/aainsight`]: singleton.getlang()?.agent_attend_insight,
		[`/main/ovinsight`]: singleton.getlang()?.outlet_visit_insight,
		[`/main/powerbiinsight`]: singleton.getlang()?.dashboard,
		[`/main/oosinsight`]: singleton.getlang()?.oos_insight,
		[`/main/rsku`]: singleton.getlang()?.rsku,
		[`/main/rdisplay`]: singleton.getlang()?.rdisplay,
		[`/main/rcompetitorpricecheck`]: singleton.getlang()?.rCompetitorPriceCheck,
		[`/main/ritemdistanalysis`]: singleton.getlang()?.item_distribution_analysis,
		[`/main/ritemdistanalysisbyagent`]: singleton.getlang()?.item_distribution_analysis_by_agent,
		[`/main/competitor`]: singleton.getlang()?.competitor_price_checking,
		[`/main/competitorgallery`]: singleton.getlang()?.competitor + " " + singleton.getlang()?.photo_gallery,
		[`/main/rcompetitorpricecheckanalysis`]: singleton.getlang()?.rCompetitorPriceCheckAnalysis,
		[`/main/rsurvey`]: singleton.getlang()?.survey_form,
		[`/main/csractivity`]: singleton.getlang()?.csr_activity,
		[`/main/rsurveyresponse`]: singleton.getlang()?.survey_response,
		[`/main/promolist`]: singleton.getlang()?.promo_list,
		[`/main/promotiontypes`]: singleton.getlang()?.promotion_types,
	};

	const [state, setState] = useState({
		theme: {
			palette: {
				type: defTheme,
				primary: {
					main: '#FEF200'
				},
				secondary: {
					main: grey[500]
				}
			}
		},
		language: singleton.getlang(),
		currentTitle: defaultRoutes[currentRoute.pathname] || 'Dashboard',
		menuLang: null
	});

	const [open, setOpen] = useState(false);
	const [liveUpdates, showLiveUpdates] = useState(false);
	const [logoutAlert, setLogoutAlert] = useState(false);

	let { theme, language, currentTitle, menuLang } = state;

	useEffect(() => {
		setGState(prev => ({
			...prev,
			translation: language,
			username: defUsername,
			client: u_client,
			defaultPhotoGallery,
			photoGalleryConfigLoaded,
			customization,
			position: u_position
		}));
	}, [customization, defUsername, defaultPhotoGallery, language, photoGalleryConfigLoaded, setGState, u_client, u_position]);

	useEffect(() => {
		if (modulesLoaded) {
			setGState(prev => ({ ...prev, authorizedModules: modules, modulesLoaded: true }));
		}
	}, [modules, modulesLoaded, setGState]);

	useEffect(() => {
		if (u_client) {
			setDefaultPhotoGallery(false);
			setPhotoGalleryConfigLoaded(false);
			const axiosGetConfig = axiosDefaultConfig(u_client);
			loadConfig(axiosGetConfig);
			loadCmsSettings(axiosGetConfig);
			loadCompanyName();
		} else {
			setDefaultPhotoGallery(false);
			setPhotoGalleryConfigLoaded(true);
		}
	}, [u_client]);

	const loadConfig = (axiosRequestConfig) => {
		API_Service.get(req_module_setting, axiosRequestConfig).then(({ data }) => {
			const { result, extraData } = data;
			if (result == 1) {
				const _config = getSetting(extraData, 'MainView', {});
				showLiveUpdates(_config.live_updates == 1);
				const _availableModules = getSetting(extraData, 'access_rights', {})[`${isAdmin}`] || [];
				setAvailableModules(_availableModules);
				setCustomization(getSetting(extraData, 'customization', {}));
				const _tutorial = getSetting(extraData, 'tutorial', {});
				setAvailableTutorials(_tutorial);
				const _modules = getSetting(extraData, 'modules', {});
				const _powerBI = getSetting(extraData, 'powerBI', {});
				setPowerBIConfig(_powerBI);

				if (!_.isEmpty(_powerBI) && (currentRoute.pathname === '/main' || currentRoute.pathname === '/main/dashboard')) {
					redirection('powerbiinsight', singleton.getlang()?.dashboard);
				}

				if (_modules.survey) {
					setSurveyModule(true);
					if (gState.client == 'kheesan' || gState.client == 'kheesan_csr') {
						setCsrActivityModule(true);
					} else {
						setSurveyResponseModule(true);
					}
				}

				if (_modules.competitor) {
					setCompetitorModule(true);
				}

				if (_modules.ItemDistributionReport) {
					setItemDistAnalysisReport(true);
					setItemDistAnalysisReportByAgent(true);
				}

				if (_modules.stockNearExpiryAnalysisByItem == true) {
					setStockNearExpiryAnalysisByItem(true);
				}

				const advancedPhotoGallery = isAdvancedPhotoGalleryEnabled(_modules.photoGalleryAdv);
				setDefaultPhotoGallery(advancedPhotoGallery);
				if (_modules.rstocknearexpiryanalysisbyday == true) {
					setStockNearExpiryAnalysisByDayModule(true);
				}
				if (_modules.oosInsight == true) {
					setOosInsightModule(true);
				}
				if (_.isArray(_modules.manageusers)) {
					_modules.manageusers = _modules.manageusers.some((name) => _.toLower(_.trim(name)) === _.toLower(_.trim(defUsername)));
				}
				if (_modules.manageusers) {
					setManageUsersModule(true);
				}
				setModules(_modules);
				setModulesLoaded(true);
			} else {
				setDefaultPhotoGallery(false);
				setCustomization({});
			}
		}).catch(() => {
			setDefaultPhotoGallery(false);
			setCustomization({});
		}).finally(() => {
			setPhotoGalleryConfigLoaded(true);
		});
		API_Service.get(req_mobile_module_setting, axiosRequestConfig).then(({ data }) => {
			const { result, extraData } = data;
			if (result == 1) {
				const { module, pdf_images } = extraData;
				const _customization = module.find((content) => content.module === 'app_calculation_percentage');
				if (_customization) {
					const { status } = _customization;
					if (status) {
						setDisplayReport(true);
					}
				}
			}
		}).finally(() => {
			setLoadingConfig(false);
		});
	}

	const loadCmsSettings = (axiosRequestConfig) => {
		API_Service.get(req_setting, axiosRequestConfig).then(({ data }) => {
			const { result, extraData } = data;
			if (result) {
				setlogoUrl(extraData[0].logo_Url);
			}
		});
	}

	const loadCompanyName = () => {
		const companyMap = {
			'em_002:': 'Greater Green',
			'dermacool:': 'DERMACOL',
			'nasty_v2:nasty_dubai': 'NASTY_DUBAI',
			'nasty_v2:nasty_malaysia': 'NASTY_MY_V2',
			'sunquick_promo:': 'OSAM Promoter',
			'sunquick_v2:bwsunquick': 'BWSUNQUICK',
			'sunquick_v2:kbsunquick': 'KBSUNQUICK_V2',
			'sunquick_v2:klsunquick': 'KLSUNQUICK',
			'sunquick_v2:jbsunquick': 'JBSUNQUICK'
		};

		const companyStr = gState.company ? JSON.parse(gState.company).join(', ') : empty;
		const key = `${gState.client}:${companyStr}`;

		if (companyMap[key]) {
			setCompanyName(companyMap[key]);
		}
	}

	const muiTheme = createTheme(theme);

	const drawerOpen = () => {
		setOpen(true);
	};

	const drawerClose = () => {
		setOpen(false);
	};

	const langMenuClick = (event) => {
		setState({
			...state,
			menuLang: event.currentTarget
		});
	};

	const closeLangMenu = (props) => {
		singleton.setlang(props);
		setState({
			...state,
			menuLang: null,
			language: singleton.getlang(),
			currentTitle: singleton.getlang()?.dashboard || 'Dashboard'
		});
		setGState({ ...gState, translation: singleton.getlang() });
		setCookie(ck_lang, props, { path: '/' });
	};

	const redirection = (path, name) => {
		History.push(`/main/${String(path).toLowerCase()}`);
		setState((prev) => ({
			...prev,
			currentTitle: name
		}));
	}

	const clearCookiesAndRedirect = () => {
		cookieClear((name) => {
			setCookie(name, empty);
			removeCookie(name, { path: '/' });
			removeCookie(name, { path: '/admin' });
			removeCookie(name, { path: '/admin/main' });
			removeCookie(name, { path: '/admin#/main' });
		});
		sessionStorage.removeItem('session');
		var timer = setTimeout(() => {
			History.push('/admin');
			clearTimeout(timer);
		}, 1000);
	}

	const cLanguage = singleton.selectedLang();

	const [tutorialDialog, setTutorialDialog] = useState(false);

	const toggleTutorials = () => {
		setTutorialDialog(true);
	}

	const closeTutorials = () => {
		setTutorialDialog(false);
	}

	return (
		<MuiThemeProvider theme={muiTheme}>
			<CookiesProvider>
				<SnackbarProvider
					classes={{
						variantSuccess: classes.whiteText,
						variantError: classes.whiteText,
						variantInfo: classes.whiteText,
						variantWarning: classes.whiteText
					}}>
					<div className={classes.root}>
						<CssBaseline />
						<AppBar
							position="fixed"
							className={clsx(classes.appBar, {
								[classes.appBarShift]: open,
							})}
							>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="open drawer"
									onClick={() => drawerOpen()}
									edge="start"
									className={clsx(classes.menuButton, {
										[classes.hide]: open,
									})}>
									<MenuIcon />
								</IconButton>
								<Typography variant="h6" noWrap className={classes.title}>
									{cLanguage === 'en' ? currentTitle.toUpperCase() : currentTitle}
								</Typography>
								<Offline polling={false}>
									<MAlert severity="error">
										{language.no_internet}
									</MAlert>
								</Offline>
								{liveUpdates && (
									<div className={classes.liveUpdateSpacer} />
								)}
								{liveUpdates && (
									<LiveUpdate
										username={defUsername}
										client={u_client}
										device_no={deviceNo}
									/>
								)}
								<AnnouncementBell
									client={u_client}
									language={language}
									onOpenAnnouncement={() => redirection('announcement', language.announcement)}
								/>
								<div className={classes.liveUpdateSpacer} />
								<Button
									color="inherit"
									onClick={langMenuClick}
									size="small"
									endIcon={<KeyboardArrowDownRoundedIcon />}
									startIcon={<GTranslateRoundedIcon />}>
									<Typography component="p">
										{cLanguage === 'en' ? 'English' : '中文'}
									</Typography>
								</Button>
								<Menu
									id="simple-menu"
									anchorEl={menuLang}
									keepMounted
									open={Boolean(menuLang)}
									onClose={() => closeLangMenu(cLanguage)}>
									<MenuItem onClick={() => closeLangMenu('en')}>English</MenuItem>
									<MenuItem onClick={() => closeLangMenu('zh')}>中文</MenuItem>
								</Menu>
								{currentTitle in availableTutorials && (
									<Tooltip title={language.tutorial_watch}>
										<IconButton
											color="inherit"
											aria-label={language.tutorial_watch}
											onClick={toggleTutorials}
											edge="end">
											<HelpIcon />
										</IconButton>
									</Tooltip>
								)}
							</Toolbar>
						</AppBar>
						<Sidebar
							open={open}
							onCollapse={drawerClose}
							onExpand={drawerOpen}
							logoUrl={logoUrl}
							companyName={companyName}
							gState={gState}
							language={language}
							cLanguage={cLanguage}
							powerBIConfig={powerBIConfig}
							defaultPhotoGallery={defaultPhotoGallery}
							promoterMode={promoterMode}
							merchandiserMode={merchandiserMode}
							availableModules={availableModules}
							modules={modules}
							displayReport={displayReport}
							competitorModule={competitorModule}
							surveyModule={surveyModule}
							surveyResponseModule={surveyResponseModule}
							csrActivityModule={csrActivityModule}
							itemDistAnalysisReport={itemDistAnalysisReport}
							itemDistAnalysisReportByAgent={itemDistAnalysisReportByAgent}
							stockNearExpiryAnalysisByItem={stockNearExpiryAnalysisByItem}
							stockNearExpiryAnalysisByDayModule={stockNearExpiryAnalysisByDayModule}
							oosInsightModule={oosInsightModule}
							manageUsersModule={manageUsersModule}
							onItemNavigate={(item) => setState((prev) => ({ ...prev, currentTitle: item.label }))}
							footerItems={[{
								key: 'logout',
								label: language.logout,
								icon: ExitToAppRoundedIcon,
								onClick: () => setLogoutAlert(true)
							}]}
						/>
						<main className={classes.content}>
							<div className={classes.content_toolbar} />
							{loadingConfig ? (
								<div className={classes.contentLoader}>
									<CircularProgress />
								</div>
							) : (
								<Router history={History}>
									<Routes />
								</Router>
							)}
						</main>
					</div>
					<Alert
						setPositive={() => setLogoutAlert(false)}
						setNegative={() => clearCookiesAndRedirect()}
						setClose={() => setLogoutAlert(false)}
						open={logoutAlert}
						title={language.es_backend}
						message={language.proceed_logout}
						positive={language.cancel}
						negative={language.logout_cap}
						autoDispossal={true}
					/>
					<TutorialVideoDialog
						open={tutorialDialog}
						title={currentTitle}
						src={tutorialDialog ? availableTutorials[currentTitle] : ''}
						onClose={closeTutorials}
					/>
				</SnackbarProvider>
			</CookiesProvider>
		</MuiThemeProvider>
	);
}
